import { ConsentContainer } from '../../_containers';

export default function CaptureCardConsentPage() {
  return (
    <ConsentContainer
      consentContentUrl='/consent/card-consent-{locale}.md'
      nextStep='capture-card-instruction'
    />
  );
}
